import React, { useCallback } from 'react';
import { RouteComponentProps } from 'react-router';

import useRouteQueryParams from 'core/hooks/useRouteQueryParams';
import useVehicleCreates from 'core/hooks/useVehicleCreates';
import { VehicleFormSchema } from 'core/schemas/vehicleForm';
import { FormSubmitHandler } from 'Elements/Form';

import VehicleForm from './VehiclePage/VehicleForm';
import VehiclePage from './VehiclePage/VehiclePage';

export default function VehicleCreate({
  history,
  location
}: RouteComponentProps) {
  const create = useVehicleCreates();
  const { redirect, ...autofill } = useRouteQueryParams<
    VehicleFormSchema['vehicle'] & { redirect: string }
  >(location);

  const onSubmit: FormSubmitHandler<VehicleFormSchema> = useCallback(
    (values, form) => {
      return create(values.vehicle)
        .then(vehicle => history.replace(redirect || `/vehicles/${vehicle.id}`))
        .catch(errors => form.setErrors({ vehicle: errors }));
    },
    [create, history, redirect]
  );

  return (
    <VehicleForm onSubmit={onSubmit} vehicle={autofill}>
      <VehiclePage title="Luo uusi ajoneuvo" />
    </VehicleForm>
  );
}
